/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmissinglunchmenu4Inputs */

const en_listingbuttonsmissinglunchmenu4 = /** @type {(inputs: Listingbuttonsmissinglunchmenu4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lunch menu yet –`)
};

const de_listingbuttonsmissinglunchmenu4 = /** @type {(inputs: Listingbuttonsmissinglunchmenu4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Mittagsmenü –`)
};

/**
* | output |
* | --- |
* | "No lunch menu yet –" |
*
* @param {Listingbuttonsmissinglunchmenu4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmissinglunchmenu4 = /** @type {((inputs?: Listingbuttonsmissinglunchmenu4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmissinglunchmenu4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmissinglunchmenu4(inputs)
	return de_listingbuttonsmissinglunchmenu4(inputs)
});
export { listingbuttonsmissinglunchmenu4 as "listingButtonsMissingLunchMenu" }